import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import toast from 'react-hot-toast';
import { truncateText } from '../../utils';
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';
const UpdatePasswordModal = ({ showModal, handleModalClose, selectedUser, submitAction }) => {
    const dispatch = useDispatch();
    const { successMsg, error: errorMsg } = useSelector(state => state.user);
    const [formData, setFormData] = useState({
        newPassword: '',
        repeatPassword: '',
    });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState({
        newPassword: false,
        repeatPassword: false
    });
    const togglePasswordVisibility = (field) => {
        setShowPassword(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setErrors({});
        let validationErrors = {}; // Temporary object to store all errors

        // Check if new password is empty
        if (!formData.newPassword || formData.newPassword.trim() === '') {
            validationErrors.newPassword = 'New Password field is empty';
        }

        // Check if repeat password is empty
        if (!formData.repeatPassword || formData.repeatPassword.trim() === '') {
            validationErrors.repeatPassword = 'Repeat New Password field is empty';
        }

        // Check if new password matches repeat password
        if (formData.newPassword !== formData.repeatPassword) {
            validationErrors.general = 'Passwords do not match!';
        }

        // If there are any errors, set them and return
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return; // Stop the form submission
        }
        submitAction(formData, selectedUser.id);

    };

    useEffect(() => {
        setErrors({});
        setFormData({
            newPassword: '',
            repeatPassword: '',
        });
        setShowPassword({
            newPassword: false,
            repeatPassword: false
        });
    }, [showModal, successMsg])

    return (
        <Modal size="xl" show={showModal} onHide={handleModalClose} backdrop="static" enforceFocus={false}>
            <Modal.Header closeButton>
                <Modal.Title>{truncateText(selectedUser.name, 30)}: Update Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xl={12} lg={12}>
                        <div className="new-user-info">
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    {/* New Password Field */}
                                    <Col md={6}>
                                        <Form.Group controlId="newPassword" className="position-relative">
                                            <Form.Label>
                                                New Password:<span className="text-danger"> * </span>
                                            </Form.Label>

                                            <div className="position-relative">
                                                <Form.Control
                                                    type={showPassword.newPassword ? "text" : "password"}
                                                    placeholder="New Password"
                                                    value={formData.newPassword}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.newPassword}
                                                />
                                                <span
                                                    className="password-toggle-icon"
                                                    onClick={() => togglePasswordVisibility('newPassword')}
                                                    style={{
                                                        cursor: 'pointer',
                                                        position: 'absolute',
                                                        right: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2,
                                                        color: '#666'
                                                    }}
                                                >
                                                    {showPassword.newPassword ? <RiEyeOffFill /> : <RiEyeFill />}
                                                </span>
                                            </div>

                                            {errors.newPassword && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.newPassword}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>

                                    {/* Repeat Password Field */}
                                    <Col md={6}>
                                        <Form.Group controlId="repeatPassword" className="position-relative">
                                            <Form.Label>
                                                Repeat New Password:<span className="text-danger"> * </span>
                                            </Form.Label>

                                            <div className="position-relative">
                                                <Form.Control
                                                    type={showPassword.repeatPassword ? "text" : "password"}
                                                    placeholder="Repeat Password"
                                                    value={formData.repeatPassword}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.repeatPassword}
                                                />
                                                <span
                                                    className="password-toggle-icon"
                                                    onClick={() => togglePasswordVisibility('repeatPassword')}
                                                    style={{
                                                        cursor: 'pointer',
                                                        position: 'absolute',
                                                        right: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        zIndex: 2,
                                                        color: '#666'
                                                    }}
                                                >
                                                    {showPassword.repeatPassword ? <RiEyeOffFill /> : <RiEyeFill />}
                                                </span>
                                            </div>

                                            {errors.repeatPassword && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.repeatPassword}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Button type="submit" className="btn btn-primary mt-3 fw-bold">
                                    Submit
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default UpdatePasswordModal
